import { Directive } from '@angular/core';
import { ValidatorFn, UntypedFormGroup, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[ssAtLeastOne]'
})
export class AtLeastOneDirective {

    static atLeastOne = (validator: ValidatorFn, controls: string[] = []) => (
        group: UntypedFormGroup,
    ): ValidationErrors | null => {

        if (!controls)
            controls = Object.keys(group.controls);

        const hasAtLeastOne = group && group.controls && controls
            .some(k => !validator(group.controls[k]));

        return hasAtLeastOne ? null : {
            atLeastOne: true,
        };
    }
}
